<div class="quick-look vertical-container">
    <h1>Mobile app for <span style="color: #0088cc;">getting things done</span> instantly</h1>
    <br>
    <p>Stay away from the hussle of doing micro tasks and let Dogo handle all your tasks, the first app which enables you to get things done by professionals in your area</p>
    <br>
    <br>
    <div class="actions-container">
        <a href="#">
            <i class="fab fa-apple"></i> Download
        </a>
        <span style="width: 16px; height: 16px;"></span>
        <a href="#">
            <i class="fab fa-google-play"></i> Download
        </a>
    </div>
</div>